/* Ported from puzzle-game.php jigsaw engine */
/* eslint-disable no-unused-expressions */
export default function JigsawPuzzle(opts) {
            const instance = this;
            this.container = null;
            this.fullImg = new Image();
            this.grid = null;
            this.key = null;
            this.mouseX = null;
            this.mouseY = null;
            this.offsetX = null;
            this.offsetY = null;
            this.touchSlot = null;
            this.dragPointer = null;
            this.dragStartX = null;
            this.dragStartY = null;
            this.lastPointerX = null;
            this.lastPointerY = null;
            this.clientX = null;
            this.clientY = null;
            this.lastPlace = null;
            this.gridSize = null;
            this.usropts = opts;
            this.difficulty = null;
            this.settings = {
                el: null,
                image: '',
                fullImg: null,
                numcolumns: 3,
                numrows: 3,
                difficulty: "normal",
                dragstart: function() {},
                dragenter: function() {},
                drag: function() {},
                dragover: function() {},
                dragleave: function() {},
                dragend: function() {},
                drop: function() {},
                touchstart: function() {},
                touchmove: function() {},
                touchhover: function() {},
                touchend: function() {},
                mousedown: function() {},
                mouseup: function() {},
                correct: function() {},
                finished: function() {},
                debug: false
            };


            // Public Methods
            this.init = function() {
                instance.setOpts(instance.usropts);
                instance.setDifficulty(instance.settings.difficulty);

                // set container
                if (instance.settings.el) {
                    instance.container = instance.settings.el;
                } else {
                    console.error(
                        'No "el" option detected. Please specify an element to attach puzzle to.');
                    return false;
                }

                // execute remaining functions after image loads
                let img = new Image();
                let width, height;
                img.onload = function() {
                    // set max height to viewport height
                    if (this.height > window.innerHeight) {
                        height = window.innerHeight;
                        width = height * (this.width / this.height);
                    } else {
                        width = this.width;
                        height = this.height;
                    }

                    // Ensure minimum dimensions
                    if (width < 100) width = 400;
                    if (height < 100) height = 400;

                    // set grid height/width based on image dimensions
                    instance.settings.width = width;
                    instance.settings.height = height;

                    // insert html into DOM
                    instance.grid = buildGrid(instance.settings.numcolumns, instance.settings
                        .numrows);
                    instance.correctTiles();
                    instance.container.innerHTML = "";
                    instance.container.appendChild(instance.grid, instance.container.children[0]);
                    setFrameDimensions(instance.grid, instance.container);
                    window.requestAnimationFrame(function() {
                        setFrameDimensions(instance.grid, instance.container);
                    });
                    setEventHandlers();
                };
                img.onerror = function() {
                    console.error('Failed to load puzzle image:', instance.settings.image);
                    instance.container.innerHTML = '<p style="padding:20px;text-align:center;">Failed to load puzzle image</p>';
                };
                img.src = instance.settings.image;

                return instance;
            };

            this.setOpts = function() {
                if (!instance.usropts) return instance;

                Object.keys(instance.usropts).forEach(function(key) {
                    if (Object.prototype.hasOwnProperty.call(instance.usropts, key)) {
                        instance.settings[key] = instance.usropts[key];
                    }
                });

                return instance;
            };

            this.setDifficulty = function(difficulty) {
                switch (difficulty) {
                    case "easy":
                        instance.difficulty = .25;
                        break;

                    case "normal":
                        instance.difficulty = .50;
                        break;

                    case "hard":
                        instance.difficulty = .75;
                        break;

                    case "expert":
                        instance.difficulty = 1;
                        break;

                    default:
                        instance.difficulty = .50;
                }

                instance.usropts.difficulty = difficulty;

                return instance;
            };

            this.setGridSize = function(obj) {
                Object.keys(obj).forEach(function(value) {
                    if (value === "numrows" && typeof Number(obj[value]) == "number") {
                        instance.usropts.numrows = obj[value];
                    }

                    if (value === "numcolumns" && typeof Number(obj[value]) == "number") {
                        instance.usropts.numcolumns = obj[value];
                    }
                });

                return instance;
            };

            this.setImage = function(src) {
                let tmpImg = new Image();
                tmpImg.onload = function() {
                    instance.usropts.image = src;
                };
                tmpImg.src = src;

                return instance;
            };

            this.isSorted = function(array) {
                array = (array) ? array : instance.getTiles();
                const len = array.length;
                if (len <= 1) return len === 1;

                let i = 0;
                let remaining = len;

                while (remaining > 1) {
                    const entry = array[i];
                    if (!entry || Number(i) !== Number(entry[0])) {
                        return false;
                    }
                    i++;
                    remaining--;
                }

                return true;
            };

            this.getTiles = function() {
                const array = [];

                if (!instance.grid) return array;

                Array.from(instance.grid.children).forEach(function(child, index) {
                    const tileDiv = child.children && child.children[0];
                    if (!tileDiv || tileDiv.dataset == null || tileDiv.dataset.position == null) {
                        return;
                    }
                    array[index] = [
                        Number(tileDiv.dataset.position) - 1,
                        child
                    ];
                });

                return array;
            };

            this.correctTiles = function(array) {

                array = (array) ? array : instance.getTiles();
                let number_correct = 0;

                for (let i = 0; i < array.length; i++) {
                    const entry = array[i];
                    if (!entry || !entry[1]) continue;

                    const slot = entry[1];
                    const tile = slot.children[0];

                    // Compare current index against original index
                    if (Number(i) === Number(entry[0])) {
                        slot.style.pointerEvents = "none";
                        slot.dataset.inplace = "true";
                        slot.classList.add('puzzle-tile-revealed');
                        if (tile) tile.dataset.inplace = "true";
                        number_correct++;
                    } else {
                        if (tile) tile.dataset.inplace = '';
                        slot.removeAttribute('data-inplace');
                        slot.classList.remove('puzzle-tile-revealed');
                        slot.style.pointerEvents = "";
                    }
                }

                return number_correct;
            };

            // Private Methods
            function isSlotLocked(slot) {
                return !slot || slot.dataset.inplace === 'true' || slot.style.pointerEvents === 'none';
            }

            function startPointerDrag(slot, clientX, clientY, offsetX, offsetY, pointerType) {
                instance.offsetX = offsetX;
                instance.offsetY = offsetY;
                instance.dragStartX = clientX;
                instance.dragStartY = clientY;
                instance.clientX = clientX;
                instance.clientY = clientY;
                instance.lastPointerX = clientX;
                instance.lastPointerY = clientY;
                instance.touchSlot = slot;
                instance.dragPointer = pointerType;

                if (slot.children[0]) {
                    slot.children[0].classList.add('highlight');
                }

                addAfterImage(slot);
                slot.style.zIndex = 10;
            }

            function movePointerDrag(clientX, clientY, evt) {
                const dragSlot = instance.touchSlot;
                if (!dragSlot) return;

                const withinBounds =
                    clientY > instance.offsetY &&
                    clientX > instance.offsetX &&
                    clientY < document.body.offsetHeight - (dragSlot.offsetHeight - instance.offsetY) &&
                    clientX < document.body.offsetWidth - (dragSlot.offsetWidth - instance.offsetX);

                if (!withinBounds) return;

                dragSlot.style.zIndex = 10;
                dragSlot.style.pointerEvents = 'none';
                dragSlot.style.transform =
                    'translate(' +
                    (clientX - instance.dragStartX) +
                    'px,' +
                    (clientY - instance.dragStartY) +
                    'px)';

                instance.lastPointerX = clientX;
                instance.lastPointerY = clientY;

                const slots = instance.grid.children;
                const params = {
                    self: instance,
                    event: evt,
                    target: evt.target,
                };

                Object.keys(slots).forEach(function(index) {
                    const rect = slots[index].getBoundingClientRect();

                    if (
                        clientX > rect.left &&
                        clientX < rect.right &&
                        clientY > rect.top &&
                        clientY < rect.bottom &&
                        slots[index] !== dragSlot
                    ) {
                        if (!slots[index].style.pointerEvents) {
                            Object.keys(instance.grid.children).forEach(function(key) {
                                instance.grid.children[key].classList.remove('highlight');
                            });
                            slots[index].classList.add('highlight');
                        }

                        if (
                            instance.settings.touchhover &&
                            typeof instance.settings.touchhover === 'function'
                        ) {
                            instance.settings.touchhover(params);
                        }
                    }
                });

            }

            function endPointerDrag(evt, endCallbackKey) {
                const dragSlot = instance.touchSlot;
                if (!dragSlot) return;

                const slots = instance.grid.children;
                const dragTile = dragSlot.children[0];
                let dropX = instance.lastPointerX;
                let dropY = instance.lastPointerY;
                if (evt.changedTouches && evt.changedTouches[0]) {
                    dropX = evt.changedTouches[0].clientX;
                    dropY = evt.changedTouches[0].clientY;
                } else if (evt.clientX != null && evt.clientY != null) {
                    dropX = evt.clientX;
                    dropY = evt.clientY;
                }

                dragSlot.style.pointerEvents = '';
                instance.grid.querySelectorAll('.highlight').forEach(function(el) {
                    el.classList.remove('highlight');
                });
                if (instance.lastPlace) {
                    instance.lastPlace.remove();
                }

                setTimeout(function() {
                    dragSlot.classList.add('animate');
                    dragSlot.style.transform = 'translate(0px,0px)';
                }, 100);

                if (!dragTile) {
                    instance.touchSlot = null;
                    instance.dragPointer = null;
                    return;
                }

                Object.keys(slots).forEach(function(index) {
                    const rect = slots[index].getBoundingClientRect();

                    if (
                        dropX > rect.left &&
                        dropX < rect.right &&
                        dropY > rect.top &&
                        dropY < rect.bottom &&
                        slots[index] !== dragSlot &&
                        !slots[index].style.pointerEvents
                    ) {
                        const slot = slots[index];
                        const tile = slot.children[0];
                        if (!tile) return;

                        dragTile.classList.remove('highlight');
                        slot.classList.remove('highlight');
                        dragSlot.style.zIndex = 10;

                        slot.appendChild(dragTile);
                        dragSlot.appendChild(tile);

                        instance.correctTiles();
                        runCallBacks(slot, dragSlot, tile, dragTile, evt);

                        Object.keys(instance.grid.children).forEach(function(key) {
                            instance.grid.children[key].classList.remove('highlight');
                        });
                    }
                });

                const endParams = {
                    self: instance,
                    event: evt,
                    target: dragSlot,
                };

                instance.touchSlot = null;
                instance.dragPointer = null;

                const endCallback = instance.settings[endCallbackKey];
                if (endCallback && typeof endCallback === 'function') {
                    endCallback(endParams);
                }
            }

            function setEventHandlers() {
                let slots = instance.grid.children;

                document.addEventListener('mousemove', function(evt) {
                    instance.mouseX = evt.clientX;
                    instance.mouseY = evt.clientY;

                    if (instance.touchSlot && instance.dragPointer === 'mouse') {
                        evt.preventDefault();
                        movePointerDrag(evt.clientX, evt.clientY, evt);
                    }
                });

                document.addEventListener('mouseup', function(evt) {
                    if (instance.touchSlot && instance.dragPointer === 'mouse') {
                        endPointerDrag(evt, 'mouseup');
                    }
                });

                document.addEventListener('transitionend', function(evt) {
                    evt.target.classList.remove('animate');
                });

                document.addEventListener('touchmove', function(evt) {
                    if (!instance.touchSlot || instance.dragPointer !== 'touch') return;

                    if (evt.cancelable) {
                        evt.preventDefault();
                    }

                    if (evt.touches[0]) {
                        movePointerDrag(evt.touches[0].clientX, evt.touches[0].clientY, evt);
                    }
                }, { passive: false });

                Object.keys(slots).forEach(function(index) {
                    slots[index].addEventListener('mousemove', function(evt) {
                        instance.offsetX = evt.offsetX;
                        instance.offsetY = evt.offsetY;
                        instance.clientX = evt.clientX;
                        instance.clientY = evt.clientY;

                        let params = {
                            self: instance,
                            event: evt,
                            target: evt.target
                        };

                        if (instance.settings.mousemove &&
                            typeof instance.settings.mousemove === "function") {
                            instance.settings.mousemove(params);
                        }
                    });

                    slots[index].addEventListener('mousedown', function(evt) {
                        if (evt.button !== 0 || isSlotLocked(this)) return;

                        evt.preventDefault();

                        const rect = this.getBoundingClientRect();
                        startPointerDrag(
                            this,
                            evt.clientX,
                            evt.clientY,
                            Math.round(evt.clientX - rect.left),
                            Math.round(evt.clientY - rect.top),
                            'mouse'
                        );

                        let params = {
                            self: instance,
                            event: evt,
                            target: evt.target
                        };

                        if (instance.settings.mousedown &&
                            typeof instance.settings.mousedown === "function") {
                            instance.settings.mousedown(params);
                        }
                    });

                    slots[index].addEventListener('touchstart', function(evt) {
                        if (isSlotLocked(this)) return;

                        if (evt.cancelable) {
                            evt.preventDefault();
                        }

                        const rect = this.getBoundingClientRect();
                        startPointerDrag(
                            this,
                            evt.touches[0].clientX,
                            evt.touches[0].clientY,
                            Math.round(evt.touches[0].clientX - rect.left),
                            Math.round(evt.touches[0].clientY - rect.top),
                            'touch'
                        );

                        let params = {
                            self: instance,
                            event: evt,
                            target: evt.target
                        };

                        if (instance.settings.touchstart &&
                            typeof instance.settings.touchstart === "function") {
                            instance.settings.touchstart(params);
                        }
                    }, { passive: false });

                    slots[index].addEventListener('touchend', function(evt) {
                        if (instance.dragPointer !== 'touch') return;
                        endPointerDrag(evt, 'touchend');
                    }, { passive: false });

                    slots[index].addEventListener('touchcancel', function(evt) {
                        if (instance.dragPointer !== 'touch') return;
                        endPointerDrag(evt, 'touchend');
                    }, { passive: false });

                    slots[index].addEventListener('transitionend', function(evt) {

                        if (evt.target.style.transform === "translate(0px, 0px)") {
                            if (instance.lastPlace !== undefined) {
                                instance.lastPlace.remove();
                            }
                            this.children[0].classList.remove('highlight');
                            this.style.zIndex = "";
                            this.style.transform = "";
                        }
                    });
                });

                window.addEventListener('resize', function() {
                    setFrameDimensions(instance.grid, instance.container);
                });
            }

            function addAfterImage(el) {
                if (instance.lastPlace) {
                    instance.lastPlace.remove();
                }

                instance.lastPlace = el.cloneNode(true);

                Object.assign(instance.lastPlace.style, {
                    'position': 'absolute',
                    'opacity': '.4',
                    'top': (el.getBoundingClientRect().top - el.parentNode.getBoundingClientRect()
                        .top) + "px",
                    'left': (el.getBoundingClientRect().left - el.parentNode.getBoundingClientRect()
                        .left) + "px",
                    'zIndex': '-2'
                });

                el.parentNode.appendChild(instance.lastPlace);
            }

            function runCallBacks(slot, dragSlot, tile, dragTile, evt) {
                let tileInPlace =
                    (Array.from(instance.grid.children).indexOf(slot) === Number(tile.dataset.position) -
                        1);
                let prevTileInPlace =
                    (Array.from(instance.grid.children).indexOf(dragSlot.parentNode) === Number(dragTile
                        .dataset.position) - 1);
                let params = {
                    self: instance,
                    event: evt,
                    target: evt.target,
                    dropped: {
                        el: tile,
                        position: tile.dataset.position,
                        inPlace: tileInPlace
                    },
                    dragged: {
                        el: dragTile,
                        position: dragTile.dataset.position,
                        inPlace: prevTileInPlace
                    }
                };

                if (instance.settings.drop &&
                    typeof instance.settings.drop === "function") {
                    instance.settings.drop(params);
                }

                if (instance.isSorted(instance.getTiles())) {

                    instance.grid.appendChild(instance.fullImg);

                    if (instance.settings.finished &&
                        typeof instance.settings.finished === "function") {
                        instance.settings.finished(params);
                    }
                }

                if (tileInPlace || prevTileInPlace) {
                    if (instance.settings.correct &&
                        typeof instance.settings.correct === "function") {
                        instance.settings.correct(params);
                    }
                }
            }

            function setFrameDimensions(grid, container) {
                const measureTarget = container.closest('.puzzle-board-shell') || container;
                let containerWidth = measureTarget.clientWidth || container.offsetWidth;

                let padding = 0;
                const paddingArr = [
                    window.getComputedStyle(measureTarget).paddingRight,
                    window.getComputedStyle(measureTarget).paddingLeft,
                ];
                paddingArr.forEach(function(value) {
                    padding += parseInt(value, 10) || 0;
                });

                containerWidth = containerWidth - padding;

                if (containerWidth < 100) {
                    containerWidth = Math.max(100, Math.min(640, window.innerWidth - 48));
                }

                const aspectRatio = instance.settings.height / instance.settings.width;
                const maxHeight = Math.min(
                    window.innerHeight * 0.58,
                    Math.max(280, window.innerWidth * 0.55)
                );
                let targetWidth = containerWidth;
                let targetHeight = containerWidth * aspectRatio;

                if (targetHeight > maxHeight) {
                    targetHeight = maxHeight;
                    targetWidth = maxHeight / aspectRatio;
                }

                Object.assign(grid.style, {
                    'display': 'flex',
                    'flex-wrap': 'wrap',
                    'box-sizing': 'border-box',
                    'max-width': '100%',
                    'width': targetWidth + 'px',
                    'height': targetHeight + 'px',
                    'max-height': maxHeight + 'px',
                    'min-width': '0',
                    'min-height': '0',
                });
            }

            instance.resize = function() {
                if (instance.grid && instance.container) {
                    setFrameDimensions(instance.grid, instance.container);
                }
                return instance;
            };

            function buildGrid(numcolumns, numrows) {
                let gridArr = [];
                let i = 0;
                instance.grid = document.createElement('ul');
                instance.gridSize = numcolumns * numrows;

                while (i < instance.gridSize) {

                    let tmpLi = document.createElement('li');
                    let tmpDiv = document.createElement('div');
                    let tmpImg = document.createElement('img');
                    let tmpArr = [];

                    const tileWidthPct = 100 / numcolumns;
                    const tileHeightPct = 100 / numrows;

                    Object.assign(tmpLi.style, {
                        'width': tileWidthPct + '%',
                        'height': tileHeightPct + '%',
                        'max-width': tileWidthPct + '%',
                        'flex': '0 0 ' + tileWidthPct + '%',
                        'box-sizing': 'border-box',
                    });

                    tmpDiv.dataset.position = i + 1;
                    tmpDiv.style.width = '100%';
                    tmpDiv.style.height = '100%';

                    tmpImg.src = instance.settings.image;
                    tmpImg.style.position = 'absolute';
                    tmpImg.style.top = '0';
                    tmpImg.style.left = '0';
                    tmpImg.style.width = 100 * numcolumns + '%';
                    tmpImg.style.height = 100 * numrows + '%';
                    tmpImg.style.maxWidth = 'none';

                    const col = i % numcolumns;
                    const row = Math.floor(i / numcolumns);
                    tmpImg.style.transform = `translate(${-col * (100 / numcolumns)}%, ${-row * (100 / numrows)}%)`;

                    tmpDiv.appendChild(tmpImg);
                    tmpLi.appendChild(tmpDiv);
                    tmpArr[0] = i;
                    tmpArr[1] = tmpLi;
                    gridArr.push(tmpArr);
                    i++;
                }

                instance.grid.classList.add("frame");
                instance.grid.classList.add("no-select");

                gridArr = shuffleArr(gridArr);
                gridArr.forEach(function(piece) {
                    instance.grid.appendChild(piece[1]);
                });

                instance.fullImg.src = (instance.settings.fullImg) ? instance.settings.fullImg : instance
                    .settings.image;
                instance.fullImg.classList.add('full-img');
                instance.fullImg.style.opacity = 0;
                instance.fullImg.style.zIndex = -1;

                return instance.grid;
            }

            function shuffleArr(array) {
                let shuffle_limit = array.length - Math.ceil(array.length * instance.difficulty);
                let m = array.length,
                    t, i;

                shuffle_limit = (shuffle_limit < (m - 1)) ? shuffle_limit : 0;

                m = (m - shuffle_limit > 0) ? m - Math.abs(shuffle_limit) : 2;

                while (m) {

                    i = Math.floor(Math.random() * (m - 1) + 1);

                    if (m < 0) {
                        break;
                    } else {
                        m--;
                    }

                    t = array[m];
                    array[m] = array[i];
                    array[i] = t;
                }

                if (instance.isSorted(array)) {
                    shuffleArr(array);
                }

                if (instance.difficulty === 1 && instance.correctTiles(array)) {
                    array.forEach(function(arr) {
                        arr[1].dataset.inplace = "";
                    });
                    shuffleArr(array);
                }

                return array;
            }

            return instance;
}
